import ShortcutsSection from '../ShortcutsSection';
import { DEFAULT_SHORTCUTS } from '../shortcutsData';

export default function AboutShortcutsSection() {
  return <ShortcutsSection items={DEFAULT_SHORTCUTS} excludeCurrent />;
}
